import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ParametersService } from '../../service/parameters.service';
import { Report, listOptions } from '../../model/settings.model';
import { Settings } from '../../model/settings.model'
import { ToastService } from '../../service/toast.service';
import { TchekStatus } from '../../model/search';
import { I18n } from '@ngx-translate/i18n-polyfill';


@Component({
  selector: 'app-parameters-reports',
  templateUrl: './parameters-reports.component.html',
  styleUrls: ['./parameters-reports.component.less']
})

export class ParametersReportsComponent implements OnInit {

  reportForm: FormGroup;
  @Input() settings: Settings;
  @Input() company: boolean;
  @Input() report: Report;
  timerEvent: NodeJS.Timer;

  constructor(private readonly _parametersService: ParametersService,
    private readonly i18n: I18n,
    private readonly _toastService: ToastService) {
    this.reportForm = new FormGroup({
      prefix: new FormControl(''),
      oldDamages: new FormControl(''),
      stateChecklist: new FormControl(''),
      statePicturesPreSelected: new FormControl(''),
      stateShowCost: new FormControl(''),
      simpleShowCost: new FormControl(''),
      stateShowSeverity: new FormControl(''),
      simpleShowSeverity: new FormControl(''),
      stateCroppImages: new FormControl(''),
      simpleCroppImages: new FormControl(''),
      simplePicturesPreSelected: new FormControl(''),
      stateVehicleDetails: new FormControl(''),
      stateSignatory: new FormControl(''),
      simpleVehicleDetails: new FormControl(''),
      simpleSignatory: new FormControl('')
    });
  }

  readonly typeValue = [
    new TchekStatus('simple', this.i18n({
      id: 'simple',
      value: 'Simple',
      description: 'Type de rapport par défault',
      meaning: "animation"
    })),
    new TchekStatus('state', this.i18n({
      id: 'state',
      value: 'Etat des lieux',
      description: 'Type de rapport par défault',
      meaning: "animation"
    })),
  ];

  readonly costValue = [
    new TchekStatus('manual', this.i18n({
      id: 'manual',
      value: 'Manuel',
      description: 'Type de chiffrage par défault',
      meaning: "animation"
    })),
    new TchekStatus('sum', this.i18n({
      id: 'sum',
      value: 'Forfaitaire',
      description: 'Type de chiffrage par défault',
      meaning: "animation"
    })),
    new TchekStatus('webservice', this.i18n({
      id: 'webservice',
      value: 'Workshop',
      description: 'Type de chiffrage par défault',
      meaning: "animation"
    })),
    new TchekStatus('ead', this.i18n({
      id: 'ead',
      value: 'EAD',
      description: 'Type de chiffrage par défault',
      meaning: "animation"
    })),
  ];

  readonly svgValue = [
    new TchekStatus('renault', this.i18n({
      id: 'renault',
      value: 'Renault Modus',
      description: 'Patron de vehicule par défault',
      meaning: "animation"
    })),
    new TchekStatus('bmw', this.i18n({
      id: 'bmw',
      value: 'BMW serie 1',
      description: 'Patron de vehicule par défault',
      meaning: "animation"
    }))
  ];

  readonly sensValue = [
    new TchekStatus('clockwise', this.i18n({
      id: 'clockwise',
      value: 'Horaire',
      description: 'Sens d`inspection du vehicule',
      meaning: "animation"
    })),
    new TchekStatus('counterclockwise', this.i18n({
      id: 'counterclockwise',
      value: 'Antihoraire',
      description: 'Sens d`inspection du vehicule',
      meaning: "animation"
    }))
  ];


  readonly svgColorsValue = [
    new TchekStatus('newDamages', this.i18n({
      id: 'newDamages',
      value: 'Nouveaux dommages',
      description: 'Nouveau Dommage',
      meaning: "animation"
    })),
    new TchekStatus('repairSeverity', this.i18n({
      id: 'repairSeverity',
      value: 'Indice de réparation',
      description: 'Indice de réparation',
      meaning: "animation"
    }))
  ];


  readonly buttonValue = [
    new TchekStatus('openpdf', this.i18n({
      id: 'openPdf',
      value: "ouvrir PDF",
      description: "ouvrir PDF",
      meaning: "parametersReports"
    })),
    new TchekStatus('sendmail', 'Envoyer par mail'),
    new TchekStatus('checksi', 'Notifier SI'),
    new TchekStatus('exportexcel', 'Export Excel')
  ];

  costSelected: string = 'manual';
  typeSelected: string = 'simple';
  buttonSelected: string = 'openpdf';
  svgSelected: string = 'renault';
  sensSelected: string = 'renault';
  svgColorSelected: string = 'newDamages';

  ngOnChange(changes: SimpleChanges) { }


  handlerChange(e) {
    this.timerEvent = setTimeout(() => {
      this.report.selectorReport = this.typeSelected;
      this.report.selectorCost = this.costSelected;
      this.report.selectorButton = this.buttonSelected;
      this.report.selectorSvg = this.svgSelected;
      this.report.selectorSens = this.sensSelected;
      this.report.selectorSvgColor = this.svgColorSelected
      this.sendData()
    }, 500);
  }

  sendData() {
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      console.log("report save", this.report);
      this._toastService.toastOpen(true);
      this._parametersService.saveReport(this.report, this.company).then((saved: Settings) => {
        this.report = saved.report;
        this._toastService.toastOpen(false);
      });
    }, 500);
  }

  ngOnInit() {
    this.costSelected = this.report.selectorCost || 'manual'
    this.typeSelected = this.report.selectorReport || 'simple'
    this.buttonSelected = this.report.selectorButton || 'openpdf'
    this.svgSelected = this.report.selectorSvg || 'renault'
    this.sensSelected = this.report.selectorSens || 'clockwise'
    this.svgColorSelected = this.report.selectorSvgColor || 'newDamages'

    if (this.report && !this.report.state)
      this.report.state = new listOptions;
    if (this.report && !this.report.simple)
      this.report.simple = new listOptions;

    this.reportForm.setValue({
      prefix: this.report.prefix || '',
      stateShowCost: this.report.state.showCost === undefined ? true : this.report.state.showCost,
      stateShowSeverity: this.report.state.showSeverity === undefined ? true : this.report.state.showSeverity,
      stateCroppImages: this.report.state.croppImages === undefined ? false : this.report.state.croppImages,
      simpleShowCost: this.report.simple.showCost === undefined ? true : this.report.simple.showCost,
      simpleCroppImages: this.report.simple.croppImages === undefined ? false : this.report.simple.croppImages,
      simpleShowSeverity: this.report.simple.showSeverity === undefined ? true : this.report.simple.showSeverity,
      oldDamages: this.report.oldDamages === undefined ? true : this.report.oldDamages,
      stateChecklist: this.report.state.checklist === undefined ? true : this.report.state.checklist,
      statePicturesPreSelected: this.report.state.picturesPreSelected === undefined ? true : this.report.state.picturesPreSelected,
      simplePicturesPreSelected: this.report.simple.picturesPreSelected === undefined ? true : this.report.simple.picturesPreSelected,
      stateVehicleDetails: this.report.state.vehicleDetails === undefined ? true : this.report.state.vehicleDetails,
      stateSignatory: this.report.state.signatory === undefined ? true : this.report.state.signatory,
      simpleVehicleDetails: this.report.simple.vehicleDetails === undefined ? true : this.report.simple.vehicleDetails,
      simpleSignatory: this.report.simple.signatory === undefined ? true : this.report.simple.signatory,
    });
    this.reportForm.valueChanges.subscribe(newValues => {
      this.report.prefix = newValues.prefix
      this.report.selectorCost = newValues.selectorCost
      this.report.selectorReport = newValues.selectorReport
      this.report.selectorButton = newValues.selectorButton
      this.report.selectorSvg = newValues.selectorSvg
      this.report.state.checklist = newValues.stateChecklist
      this.report.state.showCost = newValues.stateShowCost
      this.report.state.showSeverity = newValues.stateShowSeverity
      this.report.simple.showCost = newValues.simpleShowCost
      this.report.simple.showSeverity = newValues.simpleShowSeverity
      this.report.state.picturesPreSelected = newValues.statePicturesPreSelected
      this.report.simple.croppImages = newValues.simpleCroppImages
      this.report.state.croppImages = newValues.stateCroppImages
      this.report.simple.picturesPreSelected = newValues.simplePicturesPreSelected
      this.report.state.signatory = newValues.stateSignatory
      this.report.state.vehicleDetails = newValues.stateVehicleDetails
      this.report.simple.signatory = newValues.simpleSignatory
      this.report.simple.vehicleDetails = newValues.simpleVehicleDetails
      this.report.oldDamages = newValues.oldDamages
      this.sendData();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/element/parameters-reports/parameters-reports.component.ts